import { useState, useEffect } from "react";
import api from "../services/api";

/**
 * Hook para verificar se o módulo SMS está habilitado e configurado
 * Retorna: { enabled: boolean, loading: boolean, balance: number }
 */
const useSmsEnabled = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    const checkSmsConfig = async () => {
      try {
        setLoading(true);
        
        // Tentar buscar saldo SMS primeiro - se der 403, módulo está desativado
        try {
          await api.get("/sms/balance");
          // Se chegou aqui, módulo está ativo
          setEnabled(true);
        } catch (error) {
          // Se retornou 403, módulo está explicitamente desativado
          if (error.response && error.response.status === 403) {
            setEnabled(false);
            setLoading(false);
            return;
          }
          // Outros erros, continua verificando settings
        }
        
        // Buscar configurações do sistema
        const { data: settings } = await api.get("/settings");
        
        // Verificar se módulo SMS está explicitamente habilitado
        const smsModuleEnabled = settings.find(s => s.key === "smsModuleEnabled");
        if (smsModuleEnabled && smsModuleEnabled.value === "disabled") {
          setEnabled(false);
          setLoading(false);
          return;
        }
        
        // Verificar se as chaves necessárias existem e estão preenchidas
        // Suporta tanto configuração antiga (comteleApiKey) quanto nova (smsApiKey)
        const apiKeyOld = settings.find(s => s.key === "comteleApiKey");
        const apiKeyNew = settings.find(s => s.key === "smsApiKey");
        const apiUrlOld = settings.find(s => s.key === "comteleApiUrl");
        const apiUrlNew = settings.find(s => s.key === "smsApiUrl");
        
        // Considera configurado se tiver API key e URL (nova ou antiga)
        const hasApiKey = (apiKeyNew && apiKeyNew.value && apiKeyNew.value.trim() !== "") ||
                          (apiKeyOld && apiKeyOld.value && apiKeyOld.value.trim() !== "");
        const hasApiUrl = (apiUrlNew && apiUrlNew.value && apiUrlNew.value.trim() !== "") ||
                          (apiUrlOld && apiUrlOld.value && apiUrlOld.value.trim() !== "");
        
        const isConfigured = hasApiKey && hasApiUrl;
        
        setEnabled(isConfigured);
        
        // Se estiver configurado, buscar o saldo
        if (isConfigured) {
          try {
            const { data } = await api.get("/sms/balance");
            setBalance(data.balance || 0);
          } catch (error) {
            if (error.response && error.response.status === 403) {
              // Se der 403 aqui também, desabilita
              setEnabled(false);
            } else {
              console.warn("Erro ao buscar saldo SMS:", error);
              setBalance(0);
            }
          }
        }
      } catch (error) {
        console.error("Erro ao verificar configuração SMS:", error);
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    checkSmsConfig();
  }, []);

  return { enabled, loading, balance };
};

export default useSmsEnabled;
